// =================================================================================================
// Mona Core API
// The version of the OpenAPI document: https://core.qa1.dev.cmona.de/auto-open-api-spec.yaml 1.9.0
// Contact: https://www.clinomic.biz
//
// NOTE: This class is auto generated at 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
// by OpenAPI Generator https://openapi-generator.tech
// Do not edit the class manually.
// =================================================================================================

import camelcaseKeys from 'camelcase-keys';
import { instanceToPlain, plainToInstance, Type, Transform } from 'class-transformer';
import snakecaseKeys, { SnakeCaseKeys } from 'snakecase-keys';
import { TransformDate } from '../helpers';

/**
 * Serializes Diagnoses from database.
 * @see #/components/schemas/DiagnosisDB - reference to schema in open-api-spec.yaml
 * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
 * @version 1.9.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator
 * Do not edit this manually.
 */
export interface DiagnosisDB {
    /**
     * ICD-10 codes.
     *
     */
    code: string;
    /**
     * Name of diagnosis.
     *
     */
    display_name: string;
}
// -----------------------------------------------------------------------------
// Frontend Model
// NOTE: This class is auto generated by OpenAPI Generator
// Do not edit the class manually.
// -----------------------------------------------------------------------------

/**
 * Namespace that holds Frontend models/classes for DiagnosisDB
 */
export namespace DiagnosisDB {
    /**
     * DiagnosisDB Frontend Model with camelCase properties
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class Model {
        /**
         * ICD-10 codes.
         * @type string (`dataFormat` is missing)
         */
        code: string;
        /**
         * Name of diagnosis.
         * @type string (`dataFormat` is missing)
         */
        displayName: string;

        /** @hideconstructor */
        constructor(obj: Model) {
            Object.assign(this, camelcaseKeys(obj, { deep: true }));
        }
    }
    /**
     * DiagnosisDB DTO
     * Transforms DiagnosisDB model from/to API object
     * @since 2026-07-24T13:16:53.216391+03:00[Europe/Kiev]
     * @version 1.9.0
     *
     * NOTE: This class is auto generated by OpenAPI Generator
     * Do not edit the class manually.
     */
    export class DTO {
        /** Transforms to Frontend DiagnosisDB model */
        static toModel(obj: DiagnosisDB): Model {
            const newObj = camelcaseKeys(obj, { deep: true });
            return plainToInstance(Model, newObj);
        }
        /** Transforms to Backend DiagnosisDB model */
        static toApi(obj: Model): DiagnosisDB {
            const newObj = instanceToPlain(plainToInstance(Model, obj)) as DiagnosisDB;
            return snakecaseKeys(newObj, { deep: true });
        }
    }
}
